import { readCookie, removeDomainCookie, setDomainCookie } from './cookie';

const TOKEN_STORAGE_KEY = 'token';

export function getAuthToken() {
  return (
    localStorage.getItem(TOKEN_STORAGE_KEY) || readCookie(TOKEN_STORAGE_KEY)
  );
}

export function setAuthToken(token: string) {
  localStorage.setItem(TOKEN_STORAGE_KEY, token);
  setDomainCookie(TOKEN_STORAGE_KEY, token);
}

export function removeAuthToken() {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  removeDomainCookie(TOKEN_STORAGE_KEY);
  removeDomainCookie('subject');
  removeDomainCookie('user_store');
}
